var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"3b26d19167b401b119c86a83ed499a80c46972d8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["marketplace-front-end@vinn-q"]={id:"3b26d19167b401b119c86a83ed499a80c46972d8"};
      